import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLModElement extends HTMLElement { constructor(tagName: string = 'DEL', ownerDocument?: any) { super(tagName, ownerDocument); } }
